// extracted by mini-css-extract-plugin
export default {"category":"styles_category__s2x4J","active":"styles_active__anCtw"};